module.exports = __webpack_public_path__ + "h5/img/zhang.cbe4d28f.jpg";